const DevType = {
  DEV: 'dev',
  STAGING: 'staging',
  PROD: 'prod'
}

let devType = DevType.DEV
let BASE_API = 'http://localhost/october_cms/'
if (window.location && window.location.hostname) {
  if (window.location.hostname.includes('staging') ||
    window.location.hostname.includes('adaptconcepts')) {
    // staging
    BASE_API = 'https://cmsystem.adaptconcepts.com/october/'
    devType = DevType.STAGING
  }
  if (window.location.hostname.includes('clientmanagementprobation')) {
    // live
    BASE_API = 'https://clientmanagementprobation.com/october/'
    devType = DevType.PROD
  }
  if (window.location.hostname.includes('localhost')) {
    BASE_API = 'http://localhost/october_cms/' // localhost
    // BASE_API = 'https://cmsystem.adaptconcepts.com/october/' // azure dev
    // BASE_API: 'https://prod.clientmanagementprobation.com/october/', // prod staging
    // BASE_API = 'https://clientmanagementprobation.com/october/' // prod
    devType = DevType.DEV
    // noAria = true
  }
}

const Constants = Object.freeze({
  devType,
  BASE_API,
  BASE_API_BARE: 'https://clientmanagementprobation.com/'
  // BASE_API_BARE: 'http://localhost:8081/static/'
})

export default Constants



// WEBPACK FOOTER //
// ./src/constants.js